/* eslint-disable import/no-named-as-default */
import {combineReducers} from 'redux';
import frontEnd from './frontEnd';

export default combineReducers({
  frontEnd,
});



// WEBPACK FOOTER //
// ./src/store/reduces/index.js